// extracted by mini-css-extract-plugin
module.exports = {"popoverContent":"policies_breakdown_popoverContent__M1FeJ","popover":"policies_breakdown_popover__3duXG"};